import React, { createContext, useContext } from 'react';

export interface IDictionary {
  [key: string]: any;
}

const LocaleContext = createContext<IDictionary | null>(null);

export const LocaleProvider = ({
  children,
  dictionary,
}: {
  children: React.ReactNode;
  dictionary: IDictionary;
}) => {
  return (
    <LocaleContext.Provider value={dictionary}>
      {children}
    </LocaleContext.Provider>
  );
};

// Hook to use the dictionary in any component
export const useDictionary = () => {
  return useContext(LocaleContext);
};
